import { XS_VIEWPORT_WIDTH } from 'src/constants';

export function isMobile(windowWidth: number): boolean {
  return windowWidth <= XS_VIEWPORT_WIDTH;
}
